import MUICircularProgress from '@mui/material/CircularProgress';
import classNames from 'classnames';

/**
 * Свойства компонента {@link CircularProgress}
 */
export interface CircularProgressProps {
  /**
   * Размер кругового индикатора прогресса.
   */
  size?: number | string;

  /**
   * Цвет кругового индикатора прогресса.
   */
  color?: 'primary' | 'secondary' | 'inherit';

  /**
   * Дополнительные CSS классы для применения к круговому индикатору прогресса.
   */
  className?: string;
}

/**
 * Компонент, отображающий круговой индикатор прогресса с настраиваемым размером и цветом.
 *
 * @public
 * @param size - Размер кругового индикатора прогресса.
 * @param color - Цвет кругового индикатора прогресса.
 * @param className - Дополнительные CSS классы для применения к круговому индикатору прогресса.
 * @returns Компонент CircularProgress.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link CircularProgressProps}
 */
export const CircularProgress = ({
  size,
  color,
  className,
  ...rest
}: CircularProgressProps) => {
  return (
    <MUICircularProgress
      {...rest}
      data-testid="circular-progress"
      color={color}
      size={size}
      className={classNames(className, 'aqa_circular_progress')}
    />
  );
};
